"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _WalletDetailsComponent = _interopRequireDefault(require("./WalletDetailsComponent"));
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _baseCurrenciesSelectors = require("../../redux/selectors/baseCurrenciesSelectors");
var _selectors = require("../../redux/margin/selectors");
var _sidePaneActions = require("../../redux/actions/sidePaneActions");
var _sidePanesConstants = require("../../constants/sidePanesConstants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mapStateToProps = function mapStateToProps(state) {
  var _positionAssets$;
  var position = state.apexCore.position;
  var positionAssets = (0, _productPositionSelectors.productPositionAssetsSelector)(state);
  var selectedProductId = position.selectedProductId || ((_positionAssets$ = positionAssets[0]) === null || _positionAssets$ === void 0 ? void 0 : _positionAssets$.ProductId);
  var positionDetails = positionAssets.find(function (i) {
    return i.ProductId === selectedProductId;
  });
  var baseCurrency = (0, _baseCurrenciesSelectors.baseCurrencyPriceSelector)(state, positionDetails.ProductId);
  var verificationLevelConfig = (0, _get["default"])(state, ['user', 'verificationLevelConfigs', 'Products'], []).find(function (i) {
    return i.ProductId === position.selectedProductId;
  }) || {};
  return {
    positionDetails: positionDetails,
    fetching: (0, _productPositionSelectors.fetchingSelector)(state),
    baseCurrency: baseCurrency,
    verificationLevelConfig: verificationLevelConfig,
    isMarginActive: (0, _selectors.isMarginActiveSelector)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openWhitelistSidepane: function openWhitelistSidepane(props) {
      return dispatch((0, _sidePaneActions.openSidePane)(_sidePanesConstants.SIDE_PANES.WHITE_LIST_ADDRESS, _objectSpread(_objectSpread({}, props), {}, {
        hideHeader: true
      })));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_WalletDetailsComponent["default"]);